import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-main"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  class: "list-page-description font-mono"
};
const _hoisted_6 = {
  class: "mx-6 space-y-4 pb-6 flex-1 min-h-0 overflow-y-auto"
};
const _hoisted_7 = {
  class: "bg-white rounded-xl border border-slate-200 p-6"
};
const _hoisted_8 = {
  key: 0,
  class: "animate-pulse space-y-3"
};
const _hoisted_9 = {
  class: "grid grid-cols-2 md:grid-cols-3 gap-4 mb-5"
};
const _hoisted_10 = {
  class: "text-sm text-slate-900"
};
const _hoisted_11 = {
  class: "text-xs text-slate-500 ml-1"
};
const _hoisted_12 = {
  class: "text-sm text-slate-900"
};
const _hoisted_13 = {
  key: 0,
  class: "mb-5 bg-slate-50 rounded-xl border border-slate-200 p-4"
};
const _hoisted_14 = {
  class: "flex items-center justify-between flex-wrap gap-2"
};
const _hoisted_15 = {
  class: "text-sm text-slate-900"
};
const _hoisted_16 = {
  class: "font-mono text-xs text-slate-500 ml-1"
};
const _hoisted_17 = {
  class: "text-xs text-slate-500"
};
const _hoisted_18 = {
  key: 1,
  class: "mb-5"
};
const _hoisted_19 = {
  class: "text-sm text-slate-700"
};
const _hoisted_20 = {
  class: "grid grid-cols-3 gap-4 mb-3"
};
const _hoisted_21 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_22 = {
  class: "text-lg font-semibold text-slate-900 money-text"
};
const _hoisted_23 = {
  class: "bg-emerald-50 rounded-xl p-4"
};
const _hoisted_24 = {
  class: "text-lg font-semibold text-emerald-700 money-text"
};
const _hoisted_25 = {
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_26 = {
  class: "text-lg font-semibold text-amber-700 money-text"
};
const _hoisted_27 = {
  class: "flex items-center gap-3"
};
const _hoisted_28 = {
  class: "flex-1 h-2 bg-slate-200 rounded-full overflow-hidden"
};
const _hoisted_29 = {
  class: "text-sm text-slate-600"
};
const _hoisted_30 = {
  key: 2,
  class: "text-sm text-slate-500"
};
const _hoisted_31 = {
  class: "bg-white rounded-xl border border-slate-200 overflow-hidden"
};
const _hoisted_32 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_33 = {
  class: "flex items-center gap-3"
};
const _hoisted_34 = {
  class: "text-sm text-slate-500"
};
const _hoisted_35 = {
  class: "data-table-scroll"
};
const _hoisted_36 = {
  class: "data-table text-sm min-w-[1280px]"
};
const _hoisted_37 = {
  key: 1
};
const _hoisted_38 = {
  class: "data-table-td"
};
const _hoisted_39 = {
  class: "text-sm text-slate-900"
};
const _hoisted_40 = {
  class: "text-xs text-slate-500"
};
const _hoisted_41 = {
  class: "data-table-td"
};
const _hoisted_42 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_43 = {
  class: "data-table-td is-right"
};
const _hoisted_44 = {
  class: "money-text"
};
const _hoisted_45 = {
  class: "data-table-td"
};
const _hoisted_46 = {
  key: 0,
  class: "text-xs"
};
const _hoisted_47 = {
  class: "text-slate-900"
};
const _hoisted_48 = {
  class: "text-slate-500"
};
const _hoisted_49 = ["title"];
const _hoisted_50 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_51 = {
  class: "data-table-td text-slate-600 text-xs"
};
const _hoisted_52 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_53 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];
const _hoisted_56 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_57 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-4"
};
const _hoisted_58 = {
  class: "text-sm text-slate-600"
};
const _hoisted_59 = {
  class: "money-text text-slate-900"
};
const _hoisted_60 = {
  class: "ml-2 text-slate-500"
};
const _hoisted_61 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_62 = ["disabled"];
const _hoisted_63 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_64 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_65 = {
  key: 0,
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-4"
};
const _hoisted_66 = {
  class: "grid grid-cols-3 gap-3"
};
const _hoisted_67 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_68 = {
  class: "text-sm font-semibold text-slate-900 money-text"
};
const _hoisted_69 = {
  class: "bg-emerald-50 rounded-lg p-3"
};
const _hoisted_70 = {
  class: "text-sm font-semibold text-emerald-700 money-text"
};
const _hoisted_71 = {
  class: "bg-amber-50 rounded-lg p-3"
};
const _hoisted_72 = {
  class: "text-sm font-semibold text-amber-700 money-text"
};
const _hoisted_73 = {
  class: "bg-slate-50 rounded-xl border border-slate-200 p-4"
};
const _hoisted_74 = {
  class: "flex items-center justify-between flex-wrap gap-2 mb-3"
};
const _hoisted_75 = {
  class: "text-sm text-slate-900"
};
const _hoisted_76 = {
  class: "font-mono text-xs text-slate-500 ml-1"
};
const _hoisted_77 = {
  class: "text-xs text-slate-500"
};
const _hoisted_78 = {
  class: "rounded-lg border border-emerald-200 bg-emerald-50 p-3"
};
const _hoisted_79 = {
  class: "text-xs text-slate-500 mb-1"
};
const _hoisted_80 = {
  class: "text-sm text-slate-900"
};
const _hoisted_81 = {
  key: 0,
  class: "money-text font-semibold"
};
const _hoisted_82 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_83 = {
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_84 = {
  class: "flex flex-wrap items-end gap-3"
};
const _hoisted_85 = {
  class: "form-label"
};
const _hoisted_86 = {
  class: "flex-1 min-w-[200px]"
};
const _hoisted_87 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_88 = ["disabled"];
import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import ListPageShell from '@/components/ListPageShell.vue';
import AppModal from '@/components/AppModal.vue';
import { getFundTaskDetail, createFundTaskRecord, cancelFundTaskRecord, updateFundTaskRecordAmount } from '@/api/taxPlanning';
export default {
  __name: 'FundTaskDetail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const taskId = route.params.id;
    const taskTypeMap = {
      1: {
        label: '税筹派发',
        class: 'status-badge is-indigo'
      },
      2: {
        label: '利润回填',
        class: 'status-badge is-teal'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const taskStatusMap = {
      0: {
        label: '待处理',
        class: 'status-badge is-warning'
      },
      1: {
        label: '处理中',
        class: 'status-badge is-info'
      },
      2: {
        label: '已完成',
        class: 'status-badge is-success'
      },
      3: {
        label: '已取消',
        class: 'status-badge is-neutral'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const task = ref(null);
    const records = ref([]);
    const taskLoading = ref(false);
    const editAmountDialogVisible = ref(false);
    const editAmountRow = ref(null);
    const editAmountSubmitting = ref(false);
    const editAmountForm = reactive({
      amount: '',
      remark: ''
    });
    const handleDialogVisible = ref(false);
    const handleSubmitting = ref(false);
    const handleForm = reactive({
      amount: '',
      remark: ''
    });
    const remainingAmount = computed(() => {
      return Math.max(0, toNumber(task.value?.totalAmount) - toNumber(task.value?.completedAmount));
    });

    // 银行卡限额只展示与任务类型匹配的方向：税筹派发(1)→转出，利润回填(2)→转入
    const taskQuotaIsIn = computed(() => task.value?.taskType === 2);
    const taskCardRemaining = computed(() => taskQuotaIsIn.value ? task.value?.inRemainingQuota : task.value?.outRemainingQuota);
    const taskCardLimit = computed(() => taskQuotaIsIn.value ? task.value?.inDailyLimit : task.value?.outDailyLimit);
    const taskCardUsed = computed(() => taskQuotaIsIn.value ? task.value?.inTodayUsed : task.value?.outTodayUsed);
    const progressPercent = computed(() => {
      const totalAmount = toNumber(task.value?.totalAmount);
      if (totalAmount <= 0) return 0;
      return Math.min(100, Math.round(toNumber(task.value?.completedAmount) / totalAmount * 100));
    });
    function toNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    }
    function formatAmount(value) {
      return toNumber(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    async function fetchDetail() {
      taskLoading.value = true;
      try {
        const res = await getFundTaskDetail(taskId);
        task.value = res.task || null;
        records.value = res.records || [];
      } catch (error) {
        ElMessage.error('获取任务详情失败');
        console.error(error);
      } finally {
        taskLoading.value = false;
      }
    }
    function handleBack() {
      router.push('/tax/fund-tasks');
    }
    function openHandleDialog() {
      handleForm.amount = '';
      handleForm.remark = '';
      handleDialogVisible.value = true;
    }
    async function handleSubmitHandle() {
      const num = Number(handleForm.amount);
      if (!Number.isFinite(num) || num <= 0) {
        ElMessage.warning('请输入大于0的本笔金额');
        return;
      }
      handleSubmitting.value = true;
      try {
        await createFundTaskRecord(taskId, {
          cardId: task.value.cardId,
          amount: num,
          remark: handleForm.remark || undefined
        });
        ElMessage.success('操作已完成');
        handleDialogVisible.value = false;
        fetchDetail();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        console.error(error);
      } finally {
        handleSubmitting.value = false;
      }
    }
    async function handleCancelRecord(row) {
      const completed = row.status === 2;
      const tip = completed ? `确认取消「${row.holderName} ${row.cardNo}」这笔 ¥${formatAmount(row.amount)} 的操作记录吗？取消后任务完成金额将同步回退。` : `确认取消「${row.holderName} ${row.cardNo}」这笔 ¥${formatAmount(row.amount)} 的操作记录吗？`;
      try {
        await ElMessageBox.confirm(tip, '取消确认', {
          confirmButtonText: '确认取消',
          cancelButtonText: '再想想',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await cancelFundTaskRecord(row.id);
        ElMessage.success('取消成功');
        fetchDetail();
      } catch (error) {
        ElMessage.error(error.message || '取消失败');
        console.error(error);
      }
    }
    function openEditAmountDialog(row) {
      editAmountRow.value = row;
      editAmountForm.amount = String(row.amount ?? '');
      editAmountForm.remark = '';
      editAmountDialogVisible.value = true;
    }
    async function handleSubmitEditAmount() {
      const num = Number(editAmountForm.amount);
      if (!Number.isFinite(num) || num <= 0) {
        ElMessage.warning('请输入大于0的调整后金额');
        return;
      }
      editAmountSubmitting.value = true;
      try {
        await updateFundTaskRecordAmount(editAmountRow.value.id, {
          amount: num,
          remark: editAmountForm.remark || undefined
        });
        ElMessage.success('金额修改成功');
        editAmountDialogVisible.value = false;
        fetchDetail();
      } catch (error) {
        ElMessage.error(error.message || '修改失败');
        console.error(error);
      } finally {
        editAmountSubmitting.value = false;
      }
    }
    onMounted(() => {
      fetchDetail();
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
          class: "btn-secondary inline-flex items-center gap-1",
          onClick: handleBack
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 19l-7-7 7-7"
        })], -1), _createTextVNode(" 返回 ", -1)]))]), _cache[11] || (_cache[11] = _createElementVNode("h1", {
          class: "list-page-title"
        }, "任务详情", -1)), task.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["status-badge", taskStatusMap[task.value.status]?.class || taskStatusMap.default.class])
        }, _toDisplayString(taskStatusMap[task.value.status]?.label || '未知'), 3)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_5, _toDisplayString(task.value?.taskNo || ''), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [taskLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[12] || (_cache[12] = [_createElementVNode("div", {
          class: "h-5 bg-slate-200 rounded w-1/3"
        }, null, -1), _createElementVNode("div", {
          class: "h-4 bg-slate-200 rounded w-2/3"
        }, null, -1)]))])) : task.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "任务类型", -1)), _createElementVNode("span", {
          class: _normalizeClass(["status-badge", taskTypeMap[task.value.taskType]?.class || taskTypeMap.default.class])
        }, _toDisplayString(taskTypeMap[task.value.taskType]?.label || '未知'), 3)]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "用户", -1)), _createElementVNode("div", _hoisted_10, [_createTextVNode(_toDisplayString(task.value.applicantName || '-'), 1), _createElementVNode("span", _hoisted_11, "ID: " + _toDisplayString(task.value.applicantUserId || '-'), 1)])]), _createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "创建时间", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(task.value.createTime || '-'), 1)])]), task.value.cardId ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "text-xs text-slate-500 mr-2"
        }, "指定银行卡", -1)), _createTextVNode(" " + _toDisplayString(task.value.cardHolderName || '-') + " ", 1), _createElementVNode("span", _hoisted_16, _toDisplayString(task.value.cardNo || '-'), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(task.value.cardBankName || '-'), 1)])])) : _createCommentVNode("", true), task.value.remark ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "备注", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(task.value.remark), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "总金额", -1)), _createElementVNode("div", _hoisted_22, "¥" + _toDisplayString(formatAmount(task.value.totalAmount)), 1)]), _createElementVNode("div", _hoisted_23, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-xs text-emerald-700 mb-1"
        }, "已完成", -1)), _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString(formatAmount(task.value.completedAmount)), 1)]), _createElementVNode("div", _hoisted_25, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "text-xs text-amber-700 mb-1"
        }, "剩余", -1)), _createElementVNode("div", _hoisted_26, "¥" + _toDisplayString(formatAmount(remainingAmount.value)), 1)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
          class: "h-full bg-primary-600 rounded-full transition-all",
          style: _normalizeStyle({
            width: `${progressPercent.value}%`
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_29, _toDisplayString(progressPercent.value) + "%", 1)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_30, "任务信息加载失败"))]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_cache[22] || (_cache[22] = _createElementVNode("h3", {
          class: "text-base font-semibold text-slate-900"
        }, "操作记录", -1)), _createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, "共 " + _toDisplayString(records.value.length) + " 条", 1), task.value && task.value.cardId && ![2, 3].includes(task.value.status) ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-primary inline-flex items-center gap-1",
          onClick: openHandleDialog
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13 10V3L4 14h7v7l9-11h-7z"
        })], -1), _createTextVNode(" 处理任务 ", -1)]))])), [[_directive_permission, 'tax-planning:task:handle']]) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("table", _hoisted_36, [_cache[27] || (_cache[27] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "持卡人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "卡号"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "金额"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "操作信息"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [taskLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(3, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 6 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [...(_cache[23] || (_cache[23] = [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24"
            }, null, -1)]))], 2);
          }), 64))]);
        }), 64)) : records.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [...(_cache[24] || (_cache[24] = [_createElementVNode("td", {
          colspan: "6",
          class: "data-table-empty"
        }, "暂无操作记录", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(row.holderName || '-'), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(row.bankName || ''), 1)]), _createElementVNode("td", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(row.cardNo || '-'), 1)]), _createElementVNode("td", _hoisted_43, [_createElementVNode("span", _hoisted_44, "¥" + _toDisplayString(formatAmount(row.amount)), 1)]), _createElementVNode("td", _hoisted_45, [row.receiveConfirmTime || row.payConfirmTime ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(row.operatorName || row.payConfirmBy || row.receiveConfirmBy || '-'), 1), _createElementVNode("div", _hoisted_48, _toDisplayString(row.receiveConfirmTime || row.payConfirmTime), 1), row.remark ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-slate-500 truncate max-w-[180px]",
            title: row.remark
          }, _toDisplayString(row.remark), 9, _hoisted_49)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_50, "-"))]), _createElementVNode("td", _hoisted_51, _toDisplayString(row.createTime || '-'), 1), _createElementVNode("td", _hoisted_52, [_createElementVNode("div", _hoisted_53, [row.status === 2 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-primary",
            title: "修改金额",
            "aria-label": "修改金额",
            onClick: $event => openEditAmountDialog(row)
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_54)), [[_directive_permission, 'tax-planning:task:handle']]) : _createCommentVNode("", true), [0, 1, 2].includes(row.status) ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "取消记录",
            "aria-label": "取消记录",
            onClick: $event => handleCancelRecord(row)
          }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_55)), [[_directive_permission, 'tax-planning:task:handle']]) : _createCommentVNode("", true)])])]);
        }), 128))])])])])]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: editAmountDialogVisible.value,
          size: "md",
          onClose: _cache[4] || (_cache[4] = $event => editAmountDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_cache[29] || (_cache[29] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "修改操作记录金额", -1)), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[0] || (_cache[0] = $event => editAmountDialogVisible.value = false)
          }, [...(_cache[28] || (_cache[28] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_cache[30] || (_cache[30] = _createTextVNode(" 当前金额：", -1)), _createElementVNode("span", _hoisted_59, "¥" + _toDisplayString(formatAmount(editAmountRow.value?.amount)), 1), _createElementVNode("span", _hoisted_60, _toDisplayString(editAmountRow.value?.holderName) + " " + _toDisplayString(editAmountRow.value?.cardNo), 1)]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode("调整后金额 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editAmountForm.amount = $event),
            type: "text",
            placeholder: "请输入调整后的金额",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, editAmountForm.amount]])]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "form-label"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editAmountForm.remark = $event),
            rows: "3",
            placeholder: "可选填写修改原因",
            class: "form-textarea w-full resize-none"
          }, null, 512), [[_vModelText, editAmountForm.remark]])]), _cache[33] || (_cache[33] = _createElementVNode("p", {
            class: "text-xs text-slate-400"
          }, "修改后任务完成金额将按差额同步调整，任务完成状态会重新判定。", -1))]), _createElementVNode("div", _hoisted_61, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[3] || (_cache[3] = $event => editAmountDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: editAmountSubmitting.value,
            onClick: handleSubmitEditAmount
          }, _toDisplayString(editAmountSubmitting.value ? '提交中...' : '确认修改'), 9, _hoisted_62)])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: handleDialogVisible.value,
          size: "lg",
          onClose: _cache[9] || (_cache[9] = $event => handleDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "处理任务", -1)), _createElementVNode("p", _hoisted_64, _toDisplayString(task.value?.taskNo || ''), 1)]), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[5] || (_cache[5] = $event => handleDialogVisible.value = false)
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), task.value ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "总金额", -1)), _createElementVNode("div", _hoisted_68, "¥" + _toDisplayString(formatAmount(task.value.totalAmount)), 1)]), _createElementVNode("div", _hoisted_69, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "text-xs text-emerald-700 mb-1"
          }, "已完成", -1)), _createElementVNode("div", _hoisted_70, "¥" + _toDisplayString(formatAmount(task.value.completedAmount)), 1)]), _createElementVNode("div", _hoisted_71, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "text-xs text-amber-700 mb-1"
          }, "剩余", -1)), _createElementVNode("div", _hoisted_72, "¥" + _toDisplayString(formatAmount(remainingAmount.value)), 1)])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_cache[39] || (_cache[39] = _createElementVNode("span", {
            class: "text-xs text-slate-500 mr-2"
          }, "指定银行卡", -1)), _createTextVNode(" " + _toDisplayString(task.value.cardHolderName || '-') + " ", 1), _createElementVNode("span", _hoisted_76, _toDisplayString(task.value.cardNo || '-'), 1)]), _createElementVNode("div", _hoisted_77, _toDisplayString(task.value.cardBankName || '-'), 1)]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, _toDisplayString(taskQuotaIsIn.value ? '转入剩余限额' : '转出剩余限额'), 1), _createElementVNode("div", _hoisted_80, [taskCardRemaining.value !== null && taskCardRemaining.value !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_81, "¥" + _toDisplayString(formatAmount(taskCardRemaining.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_82, "--"))]), _createElementVNode("div", _hoisted_83, " 日限额 " + _toDisplayString(taskCardLimit.value !== null && taskCardLimit.value !== undefined ? '¥' + formatAmount(taskCardLimit.value) : '--') + " · 当日已用 ¥" + _toDisplayString(formatAmount(taskCardUsed.value)), 1)])]), _createElementVNode("div", _hoisted_84, [_createElementVNode("div", null, [_createElementVNode("label", _hoisted_85, [_createTextVNode("本笔金额（" + _toDisplayString(task.value.taskType === 2 ? '入账' : '出账') + "） ", 1), _cache[40] || (_cache[40] = _createElementVNode("span", {
            class: "text-red-500"
          }, "*", -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => handleForm.amount = $event),
            type: "text",
            placeholder: "请输入本笔金额",
            class: "form-input w-48"
          }, null, 512), [[_vModelText, handleForm.amount]])]), _createElementVNode("div", _hoisted_86, [_cache[41] || (_cache[41] = _createElementVNode("label", {
            class: "form-label"
          }, "备注", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => handleForm.remark = $event),
            type: "text",
            placeholder: "可选填写备注",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, handleForm.remark]])])]), _cache[42] || (_cache[42] = _createElementVNode("p", {
            class: "text-xs text-slate-400"
          }, "提交后该笔操作直接记为已完成，任务完成金额同步累加；如金额有误可在记录列表中修改。", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_87, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[8] || (_cache[8] = $event => handleDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: handleSubmitting.value,
            onClick: handleSubmitHandle
          }, _toDisplayString(handleSubmitting.value ? '提交中...' : '确认完成'), 9, _hoisted_88)])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};